import { WHATSAPP_NUMBER } from "@/lib/whatsapp";
import WhatsAppIcon from "@/components/WhatsAppIcon";

/** Floating WhatsApp call-to-action.
 *  - Mobile: right side, sits ~140px above the viewport bottom so it
 *    clears BOTH the 56px MobileBottomNav (safe-area-aware) AND the
 *    64px sticky "Add to Bag" bar that appears on PDPs — the button
 *    never covers "Add to Bag" any more.
 *  - Desktop: right side, standard 24px offset. */
const WhatsAppFAB = () => (
  <a
    href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hello Luxsova team 👋 I'm browsing your collection and could use some help choosing.")}`}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-fab"
    className="fixed right-4 z-[55] bottom-[calc(env(safe-area-inset-bottom,0px)+140px)] md:bottom-6 flex items-center gap-2 px-4 py-3 rounded-full shadow-xl hover:scale-105 active:scale-95 transition-transform"
    style={{
      backgroundColor: "#25D366",
      color: "#ffffff",
    }}
  >
    <WhatsAppIcon size={22} className="shrink-0" />
    <span className="text-xs font-semibold tracking-wider uppercase hidden sm:inline">
      WhatsApp
    </span>
  </a>
);

export default WhatsAppFAB;
